import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Avatar, {
  AvatarSize,
  AvatarStatus,
} from '../../../../components/Avatar';
import Button from '../../../../components/Button';
import GenericCard from '../../../../components/GenericCards/GenericCards';
import { Profile } from '../../../../types';

export type YourBeneficiariesProps = React.PropsWithChildren<{
  data: Profile[];
  handleDelete: () => void;
  handleEdit: () => void;
}>;

const YourBeneficiaries = ({
  data,
  handleDelete,
  handleEdit,
}: YourBeneficiariesProps) => {
  return (
    <Container className={'px-0 your-beneficiaries'}>
      <GenericCard className={'px-10 py-7'} variant={'white'}>
        <Row>
          <Col className={'col-12'}>
            <h6>Your Beneficiaries</h6>
          </Col>
          <Col className={'col-12'}>
            <span className={'fw-light text-fs-6 text-light-grey'}>
              View/Edit your beneficiary data.
            </span>
          </Col>
        </Row>

        <Row>
          {data.map((profile, i) => {
            return (
              <Col className={'col-12'} key={i}>
                <Container className={'position-relative px-0 py-7'}>
                  <Row>
                    <Col className={'your-beneficiaries-avatar'}>
                      <Avatar
                        id={profile.id}
                        size={AvatarSize.MEDIUM}
                        image={profile.image}
                        status={AvatarStatus.ENABLED}
                        name={profile.name}
                      />
                    </Col>
                    <Col className={'ms-7'}>
                      <Row className={'flex-column'}>
                        <Col>
                          <h6>{profile.name}</h6>
                        </Col>
                        <Col>
                          <span
                            className={'text-fs-6 fw-light text-light-grey'}
                          >
                            {profile.relationship}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col className={'px-0 d-flex beneficiary-button-wrapper'}>
                      <Button
                        onClick={handleDelete}
                        className={'p-0 beneficiary-delete-button'}
                        rightIcon={light('trash-can')}
                      />
                      <Button
                        onClick={handleEdit}
                        className={'p-0 beneficiary-edit-button'}
                        rightIcon={light('edit')}
                      />
                    </Col>
                  </Row>
                </Container>
              </Col>
            );
          })}
        </Row>
      </GenericCard>
    </Container>
  );
};

export default YourBeneficiaries;
